import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import AdvantagesSection from '../components/AdvantagesSection/AdvantagesSection';
import IconsCarousel from '../components/IconsCarousel/IconsCarousel';
import FunctionalitiesSection from '../components/FunctionalitiesSection/FunctionalitiesSection';
import Footer from '../components/Footer/Footer';

import './HomePage.scss';

function HomePage() {
  return (
    <div className="main-container">
      <Navbar />
      <section className="hero-section">
        {/* Contenu de la section héro */}
        <div className="hero-content">
          <div className="hero-text">
            <h1>Explorez, goûtez, partagez !</h1>
            <p>
              Découvrez de nouveaux restaurants, partagez vos coups de cœur
              et rejoignez une communauté de gourmands passionnés.
              C'est simple, rapide et gratuit.
            </p>

            <button className="download-apple-btn">
              <img
                src="/assets/images/pomme.png"
                alt="Apple logo"
                className="apple-logo"
              />
              <span>Disponible sur l'appstore</span>
            </button>
          </div>

          <div className="hero-image">
            <img
              src="/assets/images/logo/mascotte.png"
              alt="Mascotte TheSpot"
              className="mascotte"
            />
          </div>
        </div>
      </section>

      <section className="white-background">
        <AdvantagesSection />
        <IconsCarousel />
        <FunctionalitiesSection />
      </section>
      <Footer />
    </div>
  );
}

export default HomePage;
